exports.init = function(selector) {
  $(selector).each(function() {
    initCustomSelect($(this));
  });
};

function initCustomSelect($selectElement) {
  return;
  // Hide original select
  $selectElement.hide();

  // Create fake dropdown
  const $customSelect = $('<div class="custom-select"></div>');
  const $activeSelection = $('<div class="active-selection"></div>');
  const $selectOptions = $('<ul class="select-options"></ul>');

  // Check if any option is selected
  const $selectedOption = $selectElement.find('option:selected');
  let selectedIndex = -1;
  if ($selectedOption.length > 0) {
    selectedIndex = $selectElement.find('option').index($selectedOption);
  }

  // Populate options
  $selectElement.find('option').each(function (index) {
    const value = $(this).val();
    const text = $(this).text();
    const isDisabled = $(this).prop('disabled');
    const isHidden = $(this).prop('hidden'); // Check for hidden attribute
    const optionClassNames = 'option' + (isDisabled ? ' disabled' : '') + (isHidden ? ' hidden' : '');
    const $option = $('<li data-value="' + value + '"' +
      ' class="' + optionClassNames + '"' +
      '>' + text + '</li>');

    // Select the option if it's selected in the original select, or select the first visible option if no option is selected
    if (index === selectedIndex || (selectedIndex === -1 && !isHidden)) {
      $activeSelection.text(text);
      $option.addClass('active');
    }

    $selectOptions.append($option);
  });

  // Append elements
  $customSelect.append($activeSelection);
  $customSelect.append($selectOptions);
  $selectElement.after($customSelect);

  // Toggle custom select options
  $activeSelection.click(function (e) {
    e.stopPropagation();
    $customSelect.toggleClass('open'); // Toggle the "open" class
    $selectOptions.slideToggle(200);
  });

  // Select option in custom select
  $selectOptions.find('li:not(.disabled):not(.hidden)').click(function () {
    if ($(this).hasClass('disabled')) return; // Don't select if disabled
    const value = $(this).data('value');
    $selectElement.val(value).change(); // Change the value of original select and trigger change event
    $activeSelection.text($(this).text());

    // Remove active class from all options and add it to the clicked one
    $selectOptions.find('li').removeClass('active');
    $(this).addClass('active');

    $customSelect.removeClass('open'); // Close the custom select
    $selectOptions.slideUp(200);
  });

  // Close custom select on outside click
  $(document).click(function () {
    $customSelect.removeClass('open'); // Close the custom select
    $selectOptions.slideUp(200);
  });
}
